<div class="root-auth" *ngIf="authError">
  <p>{{ authError }}</p>
</div>
